import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import Renderer from '../canvas/renderer'
import constants from "../constants";
import PositionTools from './PositionTools';
import store from "../store";
import ResizeTextWidget from "./ResizeTextWidget";
import {setLineHeights} from "../canvas/line-height";
import TextFillWidget from "./TextFillWidget";
import TextLineWidget from "./TextLineWidget";
import util from '../util';
import TextAlignWidget from "./TextAlignWidget";
import OpacityWidget from "./OpacityWidget";
import HyperlinkWidget from './HyperlinkWidget';
import {canDisplayAlign} from "../canvas/component";
import { UnlockOutlined, BoldOutlined, ItalicOutlined, UnderlineOutlined } from "@ant-design/icons";

export default @connect(reduce, actions)
class MoreToolBarOptions extends Component {
  constructor() {
    super();

    this.manualChangeSize = this.manualChangeSize.bind(this);

    this.toggleBold = (ev) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontWeight', this.props.isBold ? 'normal' : 'bold');
      this.props.updateElementAttribute('isBold', !this.props.isBold);
    };

    this.toggleItalic = (ev) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontStyle', this.props.isItalic ? 'normal' : 'italic');
      this.props.updateElementAttribute('isItalic', !this.props.isItalic);
    };

    this.toggleUnderline = (ev) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'textDecoration', this.props.isUnderline ? 'none' : 'underline');
      this.props.updateElementAttribute('isUnderline', !this.props.isUnderline);
    };

    this.toggleUppercase = (ev) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'textTransform', this.props.isUppercase ? 'none' : 'uppercase');
      this.props.updateElementAttribute('isUppercase', !this.props.isUppercase);
    };

    this.changeFont = (font) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontFamily', font.font);
      this.props.updateElementAttribute('fontFamily', font.label);
      this.props.updateElementAttribute('fontFamilyKey', font.key);
    };

    this.changeSize = (size) => {
      const dims = Renderer.getDimensions();
      if (dims.unit === 'in') {
        const pixels = util.getPointsInPixels(size, dims);
        const percent = util.pixelToPercent(pixels, dims.fontSize);
        Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontSize', `${percent}%`, {fontSize: size});
      } else {
        const percent = size * constants.PIXEL_FONT_SIZE_ADJUSTMENT;
        Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontSize', `${percent}%`, {fontSize: size});
      }

      this.props.updateElementAttribute('fontSize', size);

      if (util.isOffPage(this.props.$element)) {
        this.props.$element.css('top', '1%');
      }
    };

    this.removeElement = () => {
      this.props.deselect();
      Renderer.remove(this.props.isMultiSelect ? this.props.$elements : this.props.$element, this.props.isMultiSelect);
    };

    this.removeGroup = () => {
      this.props.deselect();
      Renderer.remove(this.props.$element.parents('.group'));
    };

    this.copyElement = () => {
      const $clone = Renderer.copy(this.props.isMultiSelect ? this.props.$elements : this.props.$element);
      store.dispatch(actions.select($clone));
    };

    this.copyGroup = () => {
      Renderer.copy(this.props.$element.parents('.group'));
    };

    this.ungroup = () => {
      Renderer.ungroup(this.props.$element);
    };

    this.toggleLock = () => {
      if (this.props.isLocked) {
        Renderer.unlock(this.props.isMultiSelect ? this.props.$elements : this.props.$element);
      } else {
        Renderer.lock(this.props.isMultiSelect ? this.props.$elements : this.props.$element);
      }
      this.props.updateElementAttribute('isLocked', !this.props.isLocked);
    };

    this.toggleBold = () => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'fontWeight', this.props.isBold ? 'normal' : 'bold');
      this.props.updateElementAttribute('isBold', !this.props.isBold);
    };

    this.updateColor = (color) => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'color', color, {restoreSelection: false});
      this.props.updateElementAttribute('color', color);
    };

    this.updateOpacity = (ev) => {
      const val = ev.target.value;
      const $elements = this.props.isMultiSelect ? this.props.$elements.map($element => $element.find('.txt')) : [this.props.$element.find('.txt')];

      Renderer.updateElementStyle($elements, 'opacity', val / 100);
      this.props.updateElementAttribute('opacity', val);
    };

    this.updateLetterSpacing = (update, ev) => {
      const val = (ev.target.value / 10).toFixed(2);

      if (!util.isFirefox() || update) Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'letterSpacing', val + 'em');
      this.props.updateElementAttribute('letterSpacing', ev.target.value);
    };

    this.updateLineHeight = (update, ev) => {
      const val = (ev.target.value / 10).toFixed(2);

      if (!util.isFirefox() || update) {
        Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'lineHeight', val + 'em');
        setLineHeights(this.props.$element);
      }

      this.props.updateElementAttribute('lineHeight', ev.target.value);
    };

    this.textAlign = direction => {
      Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'textAlign', direction);
      this.props.updateElementAttribute('textAlign', direction);
    };
  }

  manualChangeSize(size) {
    this.changeSize(size);
  }

  render(props, state) {
    const copyOptions = props.isInGroup ?
      <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyGroup}><span>Copy</span>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"}/>
        </svg>
      </a> :
      <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyElement}><span>Copy</span>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"}/>
        </svg>
      </a>;

    const isTextHighlightMode = !!props.isTextHighlight;

    if (!props.textAlign) {
      props.textAlign = 'left';
    }

    const elementOptions = !props.isLocked &&
      <ul className={'secondary showFirstSet' + (!!isTextHighlightMode ? ' hidden' : '')}>
        {props.isInGroup && <span className="separator"/>}
        <li className={!props.isInGroup ? 'hidden more-dropdown-el' : 'more-dropdown-el'}>
          <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup}>
            <span>Ungroup</span>
          </a>
        </li>
        {canDisplayAlign(props.$element) && <li className={'more-dropdown-el'}>
          <PositionTools/>
        </li>}
        <span className="separator"/>
        {/*<li>
          <HyperlinkWidget $element={props.$element} href={props.href} isHyperlink={props.isHyperlink} updateElementAttribute={props.updateElementAttribute} hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember} />
        </li>*/}
        <span className="separator"/>
        <li className={'more-dropdown-el'}>
          {copyOptions}
        </li>
        <span className="separator"/>
        <li className={'more-dropdown-el'}>
          <a className="icn rwd-icon hint--bottom" data-hint="Lock" onClick={this.toggleLock}>
            <UnlockOutlined />
          </a>
        </li>
      </ul>;

    return (
      <div className={props.alignRight ? 'dropdown  right' : 'dropdown'}>
        <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="More"><svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-more"}/></svg></a>
        <div className="dropdown-menu moreOptions" style={'right: 0;'}>
          <ul className={'first-options'}>
            <li className="more-dropdown-el saf-stop showForthSet first-row">
              <a className={"icn tgl " + (props.isBold ? 'act' : '')} onClick={this.toggleBold}>
                <BoldOutlined/>
              </a>
            </li>
            <span className="separator showForthSet first-row"/>
            <li className="more-dropdown-el saf-stop showForthSet first-row">
              <a className={"icn tgl " + (props.isItalic ? 'act' : '')} onClick={this.toggleItalic}>
                <ItalicOutlined/>
              </a>
            </li>
            <span className="separator showForthSet first-row"/>
            <li className="more-dropdown-el saf-stop showForthSet first-row">
              <a className={"icn tgl " + (props.isUnderline ? 'act' : '')} onClick={this.toggleUnderline}>
                <UnderlineOutlined/>
              </a>
            </li>
            <span className="separator showForthSet first-row"/>
            <li className="more-dropdown-el saf-stop showForthSet first-row">
              <a className={"icn tgl " + (props.isUppercase ? 'act' : '')} onClick={this.toggleUppercase}>
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-font-size"}/>
                </svg>
              </a>
            </li>
            <span className="separator showForthSet first-row"/>
            <li className={'more-dropdown-el showThirdSet second-row'}>
              <TextAlignWidget align={props.textAlign} onAlign={this.textAlign}/>
            </li>
            <span className="separator showThirdSet second-row"/>
            <li className="more-dropdown-el saf-stop showThirdSet second-row" style={{margin: 0}}>
              <a onClick={() => props.openColorPicker(constants.pickerTypes.textFont)}>
                  <span className="color-box" style={`background: ${props.getColorCss()}; float: none;`}></span>
              </a>
            </li>
            {!isTextHighlightMode  && <span className="separator showThirdSet second-row"/>}
            <li id={"opacityTool"} className={(!!isTextHighlightMode ? ' more-dropdown-el hidden showSecondSet second-row' : 'more-dropdown-el showSecondSet second-row')}>
              <OpacityWidget onUpdate={this.updateOpacity.bind(this)} value={props.opacity}/>
            </li>
            <span className="separator showSecondSet second-row"/>
            <li id={"spacingTool"} className={'more-dropdown-el showSecondSet second-row'}>
              <div className="dropdown sizes">
                <a className="dropdown-toggle icn rwd-icon saf-stop hint--bottom" data-hint="Spacing">
                  <span>Spacing</span>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-spacing"}/>
                  </svg>
                </a>

                <div className="dropdown-menu right" data-close="no">
                  <ul className="slider-list">
                    <li className="slider-item">
                      <label className="font-spacing">Letter Spacing</label>
                      <div className="toolbar-wrap">
                        <input className="slider" type="range" min="0" max="10" step=".1" value={props.letterSpacing} onChange={this.updateLetterSpacing.bind(this, true)}
                               onMouseMove={this.updateLetterSpacing.bind(this, false)}/>
                      </div>
                      <input className="value" type="number" min="0" max="10" step=".1" disabled="disabled" value={props.letterSpacing}/>
                    </li>

                    <li className="slider-item">
                      <label className="font-spacing">Line Height</label>
                      <div className="toolbar-wrap">
                        <input className="slider" type="range" min="10" max="30" step="1" value={props.lineHeight} onChange={this.updateLineHeight.bind(this, true)}
                               onMouseMove={this.updateLineHeight.bind(this, false)}/>
                      </div>
                      <input className="value" type="number" min="10" max="30" step="1" disabled="disabled" value={props.lineHeight}/>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <span className="separator second-row"/>
            <li id={'fillTool'} className={'more-dropdown-el  second-row third-row'}>
              <TextFillWidget $element={props.$element} $elements={this.props.$elements} color={props.bgColor} opacity={props.bgOpacity} radius={props.borderRadius}
                              isMultiSelect={this.props.isMultiSelect} updateElementAttribute={props.updateElementAttribute} openColorPicker={() => props.openColorPicker(constants.pickerTypes.textFill)}/>
            </li>
            <span className="separator second-row third-row"/>
            <li className={'more-dropdown-el second-row third-row'}>
              <TextLineWidget $element={props.$element} $elements={this.props.$elements} color={props.borderBottomColor} width={props.borderBottomWidth}
                              isMultiSelect={this.props.isMultiSelect} updateElementAttribute={props.updateElementAttribute} openColorPicker={() => props.openColorPicker(constants.pickerTypes.textLine)}/>
            </li>
            {(props.isDesigner || props.isAdmin) && <span className="separator second-row third-row"/>}
            {(props.isDesigner || props.isAdmin) && <li className="more-dropdown-el second-row third-row">
              <ResizeTextWidget width={props.width} $elements={this.props.$elements} unit={props.designUnit || 'in'} $element={props.$element}
                                isMultiSelect={this.props.isMultiSelect} updateElementAttribute={props.updateElementAttribute}
              />
            </li>}
            {!props.isLocked && <span className="separator hideFourthSet second-row third-row showFirstSet"/>}
          </ul>
          {elementOptions}
        </div>
      </div>
    )
  }
}
